module.exports = __webpack_public_path__ + "img/empilhadeira.7f43e843.jpg";